import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 38.16 38.16' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='header'>
        <path
          className='cls-1'
          d='M19.08 0c-5.18 0-5.83 0-7.87.12A14 14 0 0 0 6.58 1 9.35 9.35 0 0 0 3.2 3.2 9.36 9.36 0 0 0 1 6.58a14 14 0 0 0-.89 4.63C0 13.25 0 13.9 0 19.08s0 5.83.11 7.87A14 14 0 0 0 1 31.58 9.37 9.37 0 0 0 3.2 35a9.36 9.36 0 0 0 3.38 2.2 14 14 0 0 0 4.63.89c2 .09 2.68.11 7.87.11s5.83 0 7.87-.11a14 14 0 0 0 4.63-.89 9.75 9.75 0 0 0 5.58-5.58 14 14 0 0 0 .84-4.68c.09-2 .11-2.68.11-7.87s0-5.83-.11-7.87a14 14 0 0 0-.89-4.63A9.36 9.36 0 0 0 35 3.2 9.36 9.36 0 0 0 31.57 1a14 14 0 0 0-4.63-.88C24.91 0 24.26 0 19.08 0m0 3.44c5.09 0 5.7 0 7.71.11a10.56 10.56 0 0 1 3.54.66 5.92 5.92 0 0 1 2.19 1.43 5.89 5.89 0 0 1 1.43 2.19 10.54 10.54 0 0 1 .66 3.54c.09 2 .11 2.61.11 7.71s0 5.7-.11 7.71a10.55 10.55 0 0 1-.66 3.54A6.32 6.32 0 0 1 30.33 34a10.56 10.56 0 0 1-3.54.66c-2 .09-2.61.11-7.71.11s-5.7 0-7.71-.11A10.56 10.56 0 0 1 7.83 34a5.92 5.92 0 0 1-2.19-1.43 5.9 5.9 0 0 1-1.43-2.19 10.55 10.55 0 0 1-.66-3.54c-.09-2-.11-2.62-.11-7.71s0-5.7.11-7.71a10.54 10.54 0 0 1 .66-3.54 5.91 5.91 0 0 1 1.42-2.25 5.92 5.92 0 0 1 2.2-1.42 10.56 10.56 0 0 1 3.54-.66c2-.09 2.61-.11 7.71-.11'
        />
        <path
          className='cls-1'
          d='M19.08 25.44a6.36 6.36 0 1 1 6.36-6.36 6.36 6.36 0 0 1-6.36 6.36m0-16.16a9.8 9.8 0 1 0 9.8 9.8 9.8 9.8 0 0 0-9.8-9.8M31.55 8.89a2.29 2.29 0 1 1-2.29-2.29 2.29 2.29 0 0 1 2.29 2.29'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/InstaIcon.js